import { globalPrompt } from '@/components/message'
import { useLockFn } from 'ahooks'
import { message } from 'antd'
import { createModel } from 'hox'
import { useState } from 'react'
import { supplierService } from '../../supplierService'
import { ISupplierContacts, ISupplierFormFields, ISupplierInsert, ISupplierInvoiceInfo, ISupplierUpdate } from '../../supplierTypes'

export const useSupplierDetailsMode = createModel(function () {

    const initFormVal = {} as any
    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<ISupplierFormFields>(initFormVal)
    const [editContactsList, setEditContactsList] = useState<ISupplierContacts[]>([])
    const [editInvoiceInfoList, setEditInvoiceInfoList] = useState<ISupplierInvoiceInfo[]>([])

    //新增缓存
    const [addFormVal, setAddFormVal] = useState<ISupplierFormFields>(initFormVal)
    const [addContactsList, setAddContactsList] = useState<ISupplierContacts[]>([])
    const [addInvoiceInfoList, setAddInvoiceInfoList] = useState<ISupplierInvoiceInfo[]>([])

    const [saveLoading, setSaveLoading] = useState<boolean>(false) //保存loading

    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initFormVal)
        console.log({ ...addFormVal, ...val })
    }
    //表单新增修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal(initFormVal)
    }

    //重置缓存
    const resetEditCatch = () => {
        updateEditFormVal(null) //表单
        setSaveLoading(false)
    }
    const resetAddCatch = () => {
        updateAddFormVal(null)
        setSaveLoading(false)
    }

    //获取一条数据
    const getSupplierDetailOne = async (id: string) => {
        let { retData } = await supplierService.one(id)
        if (retData) {
            let { sumSupplierInvoicingList, sumSupplierUserList,  ...formVal } = retData
            setEditFormVal(formVal)
            setEditContactsList(sumSupplierUserList || [])
            setEditInvoiceInfoList(sumSupplierInvoicingList || [])
        }
    }

    //新增 Api(包含补单)
    const insertSupplier = useLockFn(async (val: ISupplierFormFields) => {
        let data: ISupplierInsert = {
            ...addFormVal,
            ...val,
            sumSupplierInvoicingList: addInvoiceInfoList,
            sumSupplierUserList: addContactsList,
        }
        let { retData } = await supplierService.insert(data)
        if (retData) {
            globalPrompt('message', { text: '新增成功', type: 'success' })
        } else {
            globalPrompt('message', { text: '失败', type: 'error' })
        }
        return retData
    })

    //编辑 Api
    const updateSupplier = async (val: ISupplierFormFields & { id: string }) => {
        try {
            setSaveLoading(true)
            let data: ISupplierUpdate = {
                ...editFormVal,
                ...val,
                sumSupplierInvoicingList: editInvoiceInfoList,
                sumSupplierUserList: editContactsList,
            }
            let { retData } = await supplierService.update(data)
            if(retData){
                globalPrompt('message', { text: '编辑成功', type: 'success' })
                getSupplierDetailOne(val.id).then((res) => message.success('已刷新！'))
            }else{
                globalPrompt('message', { text: '编辑失败', type: 'success' })
                getSupplierDetailOne(val.id).then((res) => message.success('已刷新！'))
            }
            setSaveLoading(false)
        } catch (error) {
            setSaveLoading(false)
            getSupplierDetailOne(val.id).then((res) => message.success('页面已刷新！'))
        }
    }

     

    return {
        editFormVal,
        addFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertSupplier,
        updateSupplier,
        getSupplierDetailOne,
        resetEditCatch,
        resetAddCatch,
        saveLoading,
        setSaveLoading,
        editContactsList,
        setEditContactsList,
        addContactsList,
        setAddContactsList,
        editInvoiceInfoList,
        setEditInvoiceInfoList,
        addInvoiceInfoList,
        setAddInvoiceInfoList,

    }
})
